<template>

  <div class="index-wrap">
    <!-- :class="{ 'menuBg': gotop }" -->
    <div class="index-menu">
      <div class="header-main">
        <div class="menu">
          <a class="logo" href="javascript:;">
            <img src="../../public/assets/img/logo.png">
          </a>
          <div class="menu_left">
            <router-link to="/" exact active-class="active" class="anchor-link">首页</router-link>
            <router-link :to="{ name: 'ServiceList' }" class="anchor-link">服务列表</router-link>
            <router-link :to="{ name: 'PayMent' }" class="anchor-link">付费方式</router-link>
            <router-link :to="{ name: 'IntroduceAbout' }" class="anchor-link">关于我们</router-link>
          </div>
          <div class="phone">
            19567978183
          </div>
          <div class="info">
            <!-- {{ user }} -->
            <div v-if="user">
              <a href="https://vip.zhaobiaoguancha.cn/user/index" style="color:white">会员中心</a>
              <!-- <a href="https://vip.zhaobiaoguancha.cn/user/index" style="color:white">会员中心</a> -->
              <div class="user-info" style="display:none">
                <div class="header-usermenu">
                  <a href="javascript:;" class="header-title show_nickname">{{ user.username }}</a>
                </div>
              </div>
            </div>
            <div v-else>
              <!-- <div class="loginReg">
                <a class="reg" href="https://vip.zhaobiaoguancha.cn/user/register">注册</a>
                <router-link class="login" to="/user/login">登录</router-link>
              </div> -->
              <div class="loginReg">
                <a class="reg" href="https://vip.zhaobiaoguancha.cn/user/login?tab=register">注册</a>
                <a class="login" href="https://vip.zhaobiaoguancha.cn/user/login?tab=login">登录</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h1 class="index-theme">先知先行 快人一步</h1>
    <!-- 搜索框 -->
    <div class="index-search">
      <div class="search-wrap">
        <div class="search-theme">
          <a v-for="(con, key, index) in searchTheme" :key="key" href="javascript:;"
            :class="{ active: index === searchThemeCurrent }" @click='searchThemeFun(index, con)'>
            {{ key }}
          </a>
        </div>
        <div class="searchIndex">
          <div @click="content" class="searchSelect">
            {{ selectFault }}&nbsp;&nbsp;
            <span class="triangle"></span>
          </div>
          <div v-show='hasShow' class="searchList">
            <ul>
              <li v-for="(con, index) in select" :key="index" @click='contentDetail(index)'>
                {{ con }}
              </li>
            </ul>
          </div>
          <input type="text" :placeholder="placeholderCon" v-model="nameContent" />
          <button @click="search">搜索</button>
        </div>
        <!-- <div class="search-keyWord" style="display:block">
          <span>热门搜索</span>
          <a href="{:url('index/search/index', ['s' => '物业'])}">物业</a>
          <a href="{:url('index/search/index', ['s' => '建筑'])}">建筑</a>
          <a href="{:url('index/search/index', ['s' => '绿化'])}">绿化</a>
          <a href="{:url('index/search/index', ['s' => '大数据'])}">大数据</a>
          <a href="{:url('index/search/index', ['s' => '广告'])}">广告</a>
          <a href="{:url('index/search/index', ['s' => '机器人'])}">机器人</a>
          <a href="{:url('index/search/index', ['s' => '消防'])}">消防</a>
          <a href="{:url('index/search/index', ['s' => '保洁'])}">保洁</a>
          <a href="{:url('index/search/index', ['s' => '设备'])}">设备</a>
          <a href="{:url('index/search/index', ['s' => '装修'])}">装修</a>
          <a href="{:url('index/search/index', ['s' => '光伏'])}">光伏</a>
          <a href="{:url('index/search/index', ['s' => '防护'])}">防护</a>
        </div> -->
        <!-- <div class="search-keyWord" style="display:block">
          <span>热门搜索</span>
          <router-link :to="{ name: 'SearchPage', query: { s: '物业' } }">物业</router-link>
          <router-link :to="{ name: 'SearchPage', query: { s: '建筑' } }">建筑</router-link>
          <router-link :to="{ name: 'SearchPage', query: { s: '绿化' } }">绿化</router-link>
          <router-link :to="{ name: 'SearchPage', query: { s: '大数据' } }">大数据</router-link>
          <router-link :to="{ name: 'SearchPage', query: { s: '广告' } }">广告</router-link>
          <router-link :to="{ name: 'SearchPage', query: { s: '机器人' } }">机器人</router-link>
          <router-link :to="{ name: 'SearchPage', query: { s: '消防' } }">消防</router-link>
          <router-link :to="{ name: 'SearchPage', query: { s: '保洁' } }">保洁</router-link>
          <router-link :to="{ name: 'SearchPage', query: { s: '设备' } }">设备</router-link>
          <router-link :to="{ name: 'SearchPage', query: { s: '装修' } }">装修</router-link>
          <router-link :to="{ name: 'SearchPage', query: { s: '光伏' } }">光伏</router-link>
          <router-link :to="{ name: 'SearchPage', query: { s: '防护' } }">防护</router-link>
        </div> -->
        <div class="search-keyWord" style="display:block">
          <span>热门搜索</span>
          <a href="https://vip.zhaobiaoguancha.cn/search/list?s=物业">物业</a>
          <a href="https://vip.zhaobiaoguancha.cn/search/list?s=建筑">建筑</a>
          <a href="https://vip.zhaobiaoguancha.cn/search/list?s=绿化">绿化</a>
          <a href="https://vip.zhaobiaoguancha.cn/search/list?s=大数据">大数据</a>
          <a href="https://vip.zhaobiaoguancha.cn/search/list?s=广告">广告</a>
          <a href="https://vip.zhaobiaoguancha.cn/search/list?s=机器人">机器人</a>
          <a href="https://vip.zhaobiaoguancha.cn/search/list?s=消防">消防</a>
          <a href="https://vip.zhaobiaoguancha.cn/search/list?s=保洁">保洁</a>
          <a href="https://vip.zhaobiaoguancha.cn/search/list?s=设备">设备</a>
          <a href="https://vip.zhaobiaoguancha.cn/search/list?s=装修">装修</a>
          <a href="https://vip.zhaobiaoguancha.cn/search/list?s=光伏">光伏</a>
          <a href="https://vip.zhaobiaoguancha.cn/search/list?s=防护">防护</a>
        </div>

      </div>

    </div>
    <div class="index-banner">
      <div class="left-menus">
        <ul>
          <li class="itemTheme itemFirst">热门行业分类</li>
          <li class="item">
            <!-- <router-link :to="{ name: 'SearchPage', query: { s: '物业 保洁 保安 安保 治安 秩序 巡查 养护 环卫 清洗' } }"
              style="color:white">
              1.物业招标<span>（含物业、保洁、保安）</span>
            </router-link> -->
            <a href="https://vip.zhaobiaoguancha.cn/search/list?s=物业%20保洁%20保安%20安保%20治安%20秩序%20巡查%20养护%20环卫%20清洗"
              style="color:white">
              1.物业招标<span>（含物业、保洁、保安）</span>
            </a>
          </li>
          <li class="item">
            <a href="https://vip.zhaobiaoguancha.cn/search/list?s=服装%20工装%20床上%20窗帘%20校服%20白大褂%20工服%20制服"
              style="color:white">
              2.服装招标<span>（含布艺、窗帘、服装）</span>
            </a>
          </li>
          <li class="item">
            <a href="https://vip.zhaobiaoguancha.cn/search/list?s=餐饮%20饮承包%20饮经营%20餐饮运营%20厅经营%20餐厅服务%20厅承包%20餐厅委托%20厅托管%20餐厅管理%20餐厅招标%20堂服务%20堂外包%20堂承包%20堂承租%20堂经营%20堂运营%20堂运行%20堂托管%20堂委托%20堂社会化%20食堂管理%20饭堂管理%20食堂招标%20饭堂招标%20食堂采购%20饭堂采购%20餐服务%20餐配送%20餐供应%20供餐%20配餐"
              style="color:white">
              3.餐饮管理招标<span>（含食堂、后勤、配送）</span>
            </a>
          </li>
          <li class="item">
            <a href="https://vip.zhaobiaoguancha.cn/search/list?s=电梯" style="color:white">
              4.电梯招标<span>（含电梯安装、电梯维护）</span>
            </a>
          </li>
          <li class="item">
            <a href="https://vip.zhaobiaoguancha.cn/search/list?s=床上%20窗帘" style="color:white">
              5.窗帘招标<span>（含窗帘、床上用品、布艺）</span>
            </a>
          </li>
          <li class="item">
            <a href="https://vip.zhaobiaoguancha.cn/search/list?s=食品%20食材%20蔬菜%20肉类%20冷鲜%20海鲜%20牛奶%20生鲜%20冷冻品%20冻货%20干调%20礼盒%20慰问%20副食品%20福利%20礼品%20纪念品%20饮品%20酒水%20干货%20水果%20促销品%20米面油%20米油%20米面%20大米%20食用油%20调和油%20植物油%20葵花籽油%20瓜子油%20玉米油%20棕榈油%20花生油%20豆油%20芝麻油%20核桃油%20茶籽油%20米面油%20面粉%20食堂物%20食堂原%20食堂大宗%20大宗物资%20大宗商品%20调味品%20调味料%20调料%20果蔬%20粮油%20杂粮%20坚果%20饮食物资%20果蔬%20水果%20大宗食品"
              style="color:white">
              6.食材类招标采购
            </a>
          </li>
          <!-- <li class="item">
            <router-link :to="{ name: 'SearchPage', query: { s: '服装 工装 床上 窗帘 校服 白大褂 工服 制服' } }" style="color:white">
              2.服装招标<span>（含布艺、窗帘、服装）</span>
            </router-link>
          </li>
          <li class="item">
            <router-link
              :to="{ name: 'SearchPage', query: { s: '餐饮 饮承包 饮经营 餐饮运营 厅经营 餐厅服务 厅承包 餐厅委托 厅托管 餐厅管理 餐厅招标 堂服务 堂外包 堂承包 堂承租 堂经营 堂运营 堂运行 堂托管 堂委托 堂社会化 食堂管理 饭堂管理 食堂招标 饭堂招标 食堂采购 饭堂采购 餐服务 餐配送 餐供应 供餐 配餐' } }"
              style="color:white">
              3.餐饮管理招标<span>（含食堂、后勤、配送）</span>
            </router-link>
          </li>
          <li class="item">
            <router-link :to="{ name: 'SearchPage', query: { s: '电梯' } }" style="color:white">
              4.电梯招标<span>（含电梯安装、电梯维护）</span>
            </router-link>
          </li>
          <li class="item">
            <router-link :to="{ name: 'SearchPage', query: { s: '床上 窗帘' } }" style="color:white">
              5.窗帘招标<span>（含窗帘、床上用品、布艺）</span>
            </router-link>
          </li>
          <li class="item">
            <router-link
              :to="{ name: 'SearchPage', query: { s: '食品 食材 蔬菜 肉类 冷鲜 海鲜 牛奶 生鲜 冷冻品 冻货 干调 礼盒 慰问 副食品 福利 礼品 纪念品 饮品 酒水 干货 水果 促销品 米面油 米油 米面 大米 食用油 调和油 植物油 葵花籽油 瓜子油 玉米油 棕榈油 花生油 豆油 芝麻油 核桃油 茶籽油 米面油 面粉 食堂物 食堂原 食堂大宗 大宗物资 大宗商品 调味品 调味料 调料 果蔬 粮油 杂粮 坚果 饮食物资 果蔬 水果 大宗食品' } }"
              style="color:white">
              6.食材类招标采购
            </router-link>
          </li> -->
        </ul>
      </div>
      <!-- <div class="left-menus">
        <ul>
          <li class="itemTheme itemFirst">热门行业分类</li>
          <li class="item"><a style="color:white"
              href="{:url('index/search/index', ['s' => '物业 保洁 保安 安保 治安 秩序 巡查 养护 环卫 清洗'])}">1.物业招标<span>（含物业、保洁、保安）</span></a>
          </li>
          <li class="item"><a style="color:white"
              href="{:url('index/search/index', ['s' => '服装 工装 床上 窗帘 校服 白大褂 工服 制服'])}">2.服装招标<span>（含布艺、窗帘、服装）</span></a>
          </li>
          <li class="item"><a style="color:white"
              href="{:url('index/search/index', ['s' => '餐饮 饮承包 饮经营 餐饮运营 厅经营 餐厅服务 厅承包 餐厅委托 厅托管 餐厅管理 餐厅招标 堂服务 堂外包 堂承包 堂承租 堂经营 堂运营 堂运行 堂托管 堂委托 堂社会化 食堂管理 饭堂管理 食堂招标 饭堂招标 食堂采购 饭堂采购 餐服务 餐配送 餐供应 供餐 配餐'])}">3.餐饮管理招标<span>（含食堂、后勤、配送）</span></a>
          </li>
          <li class="item"><a style="color:white"
              href="{:url('index/search/index', ['s' => '电梯'])}">4.电梯招标<span>（含电梯安装、电梯维护）</span></a>
          </li>
          <li class="item"><a style="color:white"
              href="{:url('index/search/index', ['s' => '床上 窗帘'])}">5.窗帘招标<span>（含窗帘、床上用品、布艺）</span></a>
          </li>
          <li class="item"><a style="color:white"
              href="{:url('index/search/index', ['s' => '食品 食材 蔬菜 肉类 冷鲜 海鲜 牛奶 生鲜 冷冻品 冻货 干调 礼盒 慰问 副食品 福利 礼品 纪念品 饮品 酒水 干货 水果 促销品 米面油 米油 米面 大米 食用油 调和油 植物油 葵花籽油 瓜子油 玉米油 棕榈油 花生油 豆油 芝麻油 核桃油 茶籽油 米面油 面粉 食堂物 食堂原 食堂大宗 大宗物资 大宗商品 调味品 调味料 调料 果蔬 粮油 杂粮 坚果 饮食物资 果蔬 水果 大宗食品'])}">6.食材类招标采购<span></span></a>
          </li>
        </ul>
      </div> -->
      <!-- <div class="left-menus">
        <ul>
          <li class="itemTheme itemFirst">热门行业分类</li>
          <li class="item">
            <router-link to="{ path: '/index/search', query: { s: '物业 保洁 保安 安保 治安 秩序 巡查 养护 环卫 清洗' } }"
              style="color: white">
              1.物业招标<span>（含物业、保洁、保安）</span>
            </router-link>
          </li>
          <li class="item">
            <router-link to="{ path: '/index/search', query: { s: '服装 工装 床上 窗帘 校服 白大褂 工服 制服' } }" style="color: white">
              2.服装招标<span>（含布艺、窗帘、服装）</span>
            </router-link>
          </li>
          <li class="item">
            <router-link
              to="{ path: '/index/search', query: { s: '餐饮 饮承包 饮经营 餐饮运营 厅经营 餐厅服务 厅承包 餐厅委托 厅托管 餐厅管理 餐厅招标 堂服务 堂外包 堂承包 堂承租 堂经营 堂运营 堂运行 堂托管 堂委托 堂社会化 食堂管理 饭堂管理 食堂招标 饭堂招标 食堂采购 饭堂采购 餐服务 餐配送 餐供应 供餐 配餐' } }"
              style="color: white">
              3.餐饮管理招标<span>（含食堂、后勤、配送）</span>
            </router-link>
          </li>
          <li class="item">
            <router-link to="{ path: '/index/search', query: { s: '电梯' } }" style="color: white">
              4.电梯招标<span>（含电梯安装、电梯维护）</span>
            </router-link>
          </li>
          <li class="item">
            <router-link to="{ path: '/index/search', query: { s: '床上 窗帘' } }" style="color: white">
              5.窗帘招标<span>（含窗帘、床上用品、布艺）</span>
            </router-link>
          </li>
          <li class="item">
            <router-link
              to="{ path: '/index/search', query: { s: '食品 食材 蔬菜 肉类 冷鲜 海鲜 牛奶 生鲜 冷冻品 冻货 干调 礼盒 慰问 副食品 福利 礼品 纪念品 饮品 酒水 干货 水果 促销品 米面油 米油 米面 大米 食用油 调和油 植物油 葵花籽油 瓜子油 玉米油 棕榈油 花生油 豆油 芝麻油 核桃油 茶籽油 米面油 面粉 食堂物 食堂原 食堂大宗 大宗物资 大宗商品 调味品 调味料 调料 果蔬 粮油 杂粮 坚果 饮食物资 果蔬 水果 大宗食品' } }"
              style="color: white">
              6.食材类招标采购<span></span>
            </router-link>
          </li>
        </ul>
      </div> -->
      <div id="banner-slide" class="banner-slideWrap">
        <div class="swiper-container">
          <!-- Swiper 滑块内容 -->
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(image, index) in banners" :key="index">
              <img :src="image.src" :alt="image.alt" />
            </div>
          </div>
          <!-- Swiper 分页器 -->
          <div class="swiper-pagination"></div>
          <!-- Swiper 导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </div>
    <!-- 中间引导部分 -->
    <div class="lead clear">
      <div class="lead-container">
        <div class="item">
          <!-- <router-link to="/index/search?c=招标预告" tag="div" class="clickable-block">
            <span>预告</span>
            <div class="itemRight">
              <h4>招标预告</h4>
              <div class="lead-a">
                <a href="javascript:;">政府招标预告</a>
                <a href="javascript:;">工程招标预告</a>
              </div>
            </div>
          </router-link> -->
          <a href="https://vip.zhaobiaoguancha.cn/search/list?c=招标预告" class="clickable-block">
            <span>预告</span>
            <div class="itemRight">
              <h4>招标预告</h4>
              <div class="lead-a">
                <a href="javascript:;">政府招标预告</a>
                <a href="javascript:;">工程招标预告</a>
              </div>
            </div>
          </a>
        </div>
        <div class="item">
          <a href="https://vip.zhaobiaoguancha.cn/search/list?c=招标公告" class="clickable-block">
            <!-- <router-link to="/index/search?c=招标公告" tag="div" class="clickable-block"> -->
            <span>公告</span>
            <div class="itemRight">
              <h4>招标公告</h4>
              <div class="lead-a">
                <a href="javascript:;">政府招标公告</a>
                <a href="javascript:;">工程招标公告</a>
              </div>
            </div>
            <!-- </router-link> -->
          </a>
        </div>
        <div class="item">
          <!-- <a href="{:url('index/search/index', ['c' => 3])}">  -->
          <a href="https://vip.zhaobiaoguancha.cn/search/list?c=变更公告" class="clickable-block">
            <!-- <router-link to="/index/search?c=变更公告" tag="div" class="clickable-block"> -->
            <span>变更</span>
            <div class="itemRight">
              <h4>变更公告</h4>
              <div class="lead-a">
                <a href="javascript:;">政府变更公告</a>
                <a href="javascript:;">工程变更公告</a>
              </div>
            </div>
          </a>
          <!-- </router-link> -->
        </div>
        <div class="item">
          <!-- <router-link to="/index/search?c=中标公告" tag="div" class="clickable-block"> -->
          <a href="https://vip.zhaobiaoguancha.cn/search/list?c=中标公告" class="clickable-block">

            <span>中标</span>
            <div class="itemRight">
              <h4>中标公告</h4>
              <div class="lead-a">
                <a href="javascript:;">政府中标公告</a>
                <a href="javascript:;">工程中标公告</a>
              </div>
            </div>
          </a>
          <!-- </router-link> -->
        </div>
        <div class="item">
          <!-- <a href="{:url('index/search/index', ['c' => 5])}"> <span>信息</span> -->
          <!-- <router-link to="/index/search?c=拟建项目" tag="div" class="clickable-block"> -->
          <a href="https://vip.zhaobiaoguancha.cn/search/list?c=拟建项目" class="clickable-block">
            <div class="itemRight">
              <h4>项目信息</h4>
              <div class="lead-a">
                <a href="javascript:;">政府项目信息</a>
                <a href="javascript:;">工程项目信息</a>
              </div>
            </div>
          </a>
          <!-- </router-link> -->
        </div>
      </div>
    </div>
    <!-- 中间主要部分 -->
    <div class="main-container clear">
      <!-- 右侧导航 -->
      <div class="right-nav">
        <a href="javascript:;" v-show='gotop' class="nav-item" @click='scrollTop'>回到<br>顶部</a>
      </div>
      <div class="left-container" id="left-container">
        <div id="leftCon-1" class="item">
          <div class="item-hover">
            <a href="javascript:;">
              <h1>招标预告</h1>
              <em></em>
            </a>
            <p>
              <a href="javascript:;">提供采购计划预告通知、报名邀请等准备信息。</a>
            </p>
          </div>
          <div class="container-list">
            <div class="item-group">
              <!-- <router-link v-for="vo in info2" :key="vo.id" :to="{ path: '/search/detail', query: { id: vo.id } }"
                target="_blank" class="item">
                <h5>{{ vo.title }}</h5>
                <h6 class="tag">
                  <span>{{ vo.provinceName + (vo.cityName ? '-' + vo.cityName : '') }}</span>
                  <span>{{ vo.tenderCategoryName }}</span>
                </h6>
                <p>{{ vo.createTime }}</p>
              </router-link> -->
              <a v-for="vo in info2" :key="vo.id" :href="`https://vip.zhaobiaoguancha.cn/search/detail?id=${vo.id}`"
                target="_blank" class="item">
                <h5>{{ vo.title }}</h5>
                <h6 class="tag">
                  <span>{{ vo.provinceName + (vo.cityName ? '-' + vo.cityName : '') }}</span>
                  <span>{{ vo.tenderCategoryName }}</span>
                </h6>
                <p>{{ vo.createTime }}</p>
              </a>
            </div>
            <!-- 查看更多链接 -->
            <a href="https://vip.zhaobiaoguancha.cn/search/list?c=招标预告" class="more">查看更多</a>
            <!-- <router-link to="/index/search?c=招标预告" class="more">查看更多</router-link> -->

          </div>
        </div>
        <div id="leftCon-1" class="item">
          <div class="item-hover">
            <a href="javascript:;">
              <h1>招标公告</h1>
            </a>
            <p>
              <a href="javascript:;">提供全国各政府采购中心、招标代理机构及业主单位等招标采购信息。</a>
            </p>
          </div>
          <div class="container-list">
            <div class="item-group">
              <!-- <router-link v-for="vo in info1" :key="vo.id" :to="{ path: '/search/detail', query: { id: vo.id } }"
                target="_blank" class="item">
                <h5>{{ vo.title }}</h5>
                <h6 class="tag">
                  <span>{{ vo.provinceName + (vo.cityName ? '-' + vo.cityName : '') }}</span>
                  <span>{{ vo.tenderCategoryName }}</span>
                </h6>
                <p>{{ vo.createTime }}</p>
              </router-link> -->
              <a v-for="vo in info1" :key="vo.id" :href="`https://vip.zhaobiaoguancha.cn/search/detail?id=${vo.id}`"
                target="_blank" class="item">
                <h5>{{ vo.title }}</h5>
                <h6 class="tag">
                  <span>{{ vo.provinceName + (vo.cityName ? '-' + vo.cityName : '') }}</span>
                  <span>{{ vo.tenderCategoryName }}</span>
                </h6>
                <p>{{ vo.createTime }}</p>
              </a>
            </div>
            <!-- <router-link to="/index/search?c=招标公告" class="more">查看更多</router-link> -->
            <a href="https://vip.zhaobiaoguancha.cn/search/list?c=招标公告" class="more">查看更多</a>
          </div>
        </div>
        <div id="leftCon-1" class="item">
          <div class="item-hover">
            <a href="javascript:;">
              <h1>变更公告</h1>
              <em></em>
            </a>
            <p>
              <a href="javascript:;">提供补充公告、变更公告、废标公告、重新招标等信息。</a>
            </p>
          </div>
          <div class="container-list">
            <div class="item-group">
              <!-- <router-link v-for="vo in info3" :key="vo.id" :to="{ path: '/search/detail', query: { id: vo.id } }"
                target="_blank" class="item">
                <h5>{{ vo.title }}</h5>
                <h6 class="tag">
                  <span>{{ vo.provinceName + (vo.cityName ? '-' + vo.cityName : '') }}</span>
                  <span>{{ vo.tenderCategoryName }}</span>
                </h6>
                <p>{{ vo.createTime }}</p>
              </router-link> -->
              <a v-for="vo in info3" :key="vo.id" :href="`https://vip.zhaobiaoguancha.cn/search/detail?id=${vo.id}`"
                target="_blank" class="item">
                <h5>{{ vo.title }}</h5>
                <h6 class="tag">
                  <span>{{ vo.provinceName + (vo.cityName ? '-' + vo.cityName : '') }}</span>
                  <span>{{ vo.tenderCategoryName }}</span>
                </h6>
                <p>{{ vo.createTime }}</p>
              </a>
            </div>
            <!-- <router-link to="/index/search?c=变更公告" class="more">查看更多</router-link> -->
            <a href="https://vip.zhaobiaoguancha.cn/search/list?c=变更公告" class="more">查看更多</a>
          </div>
        </div>
        <div id="leftCon-1" class="item">
          <div class="item-hover">
            <a href="javascript:;">
              <h1>中标公告</h1>
              <em></em>
            </a>
            <p>
              <a href="javascript:;">提供中标单位、中标项目、中标金额等信息。</a>
            </p>
          </div>
          <div class="container-list">
            <div class="item-group">
              <!-- <router-link v-for="vo in info4" :key="vo.id" :to="{ path: '/search/detail', query: { id: vo.id } }"
                target="_blank" class="item">
                <h5>{{ vo.title }}</h5>
                <h6 class="tag">
                  <span>{{ vo.provinceName + (vo.cityName ? '-' + vo.cityName : '') }}</span>
                  <span>{{ vo.tenderCategoryName }}</span>
                </h6>
                <p>{{ vo.createTime }}</p>
              </router-link> -->
              <a v-for="vo in info4" :key="vo.id" :href="`https://vip.zhaobiaoguancha.cn/search/detail?id=${vo.id}`"
                target="_blank" class="item">
                <h5>{{ vo.title }}</h5>
                <h6 class="tag">
                  <span>{{ vo.provinceName + (vo.cityName ? '-' + vo.cityName : '') }}</span>
                  <span>{{ vo.tenderCategoryName }}</span>
                </h6>
                <p>{{ vo.createTime }}</p>
              </a>
            </div>
            <!-- <router-link to="/index/search?c=中标公告" class="more">查看更多</router-link> -->
            <a href="https://vip.zhaobiaoguancha.cn/search/list?c=中标公告" class="more">查看更多</a>
          </div>
        </div>
      </div>
    </div>
    <div class="feature">
      <div class="feature-head">
        <h2>会员优势</h2>
      </div>
      <div class="feature-con">
        <ul>
          <li class="feature-item">
            <i class="icon-user iconStyle"></i>
            <h3>招标采购查询</h3>
            <p class="textDisc"> 每天更新近9万条招标采购信息及时、全面、准确。轻松参与投标</p>
          </li>
          <li class="feature-item">
            <i class="icon-screen-smartphone iconStyle"></i>
            <h3>前期项目查询</h3>
            <p class="textDisc">每天更新近万条前期项目、规划项目、环评项目。方便前期洽谈</p>
          </li>
          <li class="feature-item">
            <i class="icon-present iconStyle"></i>
            <h3>项目进度跟踪</h3>
            <p class="textDisc">全程跟踪项目建设进展，专职人员专业跟进。短信、邮件、电话实时反馈</p>
          </li>
          <li class="feature-item">
            <i class="icon-layers iconStyle"></i>
            <h3>专题信息定制</h3>
            <p class="textDisc">根据企业业务需求，个性定制，精准推送企业关注的招标采购信息</p>
          </li>
          <li class="feature-item">
            <i class="icon-docs iconStyle"></i>
            <h3>产品精准营销</h3>
            <p class="textDisc">依托强大采购数据，实时推送企业产品致采购需求负责人手机和邮箱</p>
          </li>
          <li class="feature-item">
            <i class="icon-puzzle iconStyle"></i>
            <h3>唯一推荐入围</h3>
            <p class="textDisc">根据企业业务特点匹配，筛选最佳采购需求，唯一推荐企业入围项目采购预选名单</p>
          </li>
        </ul>
      </div>
    </div>
    <div style="clear: both;"></div>
    <div class="cta">
      <div class="cta-content">
        <div class="cta-left">
          <h2>不要犹豫<br>加入我们</h2>
          <a href="https://vip.zhaobiaoguancha.cn/user/login?tab=register" class='btn'>注册</a>
        </div>
        <div class="cta-right">
          <p>公司名称：石家庄速证科技有限公司</p>
          <p>公司地址：河北省石家庄市新华区中华北大街198号
            <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中储广场B座2单元0705
          </p>
          <p>联系电话：19567978183</p>
        </div>
      </div>

      <div class="overlay"></div>
      <!-- <div class="ctab
              <img src="./img/cta.jpg">
          </div>-->

    </div>
    <!-- <div class="qr">
      <img src="https://www.zg-cgw.cn/qr.png" width="180" alt="二维码">
    </div> -->
    <!-- 底部链接 -->
    <div class="footer">
      <p class="copyright">Copyright&nbsp;©&nbsp;2017-2025 All Rights Reserved 石家庄速证科技有限公司 <a
          href="https://beian.miit.gov.cn">冀ICP备2024090107号-2</a> </p>
      <!--<p class="copyright">-->
      <!--    © 2017-2025 河北泽能信息科技有限公司 All Rights Reserved.-->
      <!--</p>-->
    </div>
  </div>


</template>

<script src="../../public/assets/static/js/swiper.min.js"></script>

<script>
import axios from "axios";
import { getWithExpiry } from '@/utils/globalFunctions'; // 直接导入函数
import { USER_TOKEN } from '@/utils/CommonConstant'; // 直接导入函数

export default {
  data() {
    return {
      banners: [
        { src: "./assets/static/img/banner-2.png", alt: "轮播图" },
        { src: "./assets/static/img/cta.jpg", alt: "轮播图" },
      ],
      info1: [],
      info2: [], // 用于存储接口返回的列表数据
      info3: [], // 存储接口返回的数据
      info4: [], // 用于存储 API 返回的 info4 数据
      user: null, // 存储用户信息，如果未登录则为 null
      gotop: false,
      hasShow: false,
      select: ['招标公告', '招标预告', '变更公告', '中标公告', '拟建项目', 'VIP项目'],
      selectFault: '招标公告',
      nameContent: '',
      // index: 1,
      searchThemeCurrent: 0,
      placeholderCon: '请输入您要查询的招标采购、企业名相关信息',
      //searchTheme: { '全部': '请输入您要查询的招标采购、企业名相关信息', '招标采购': '请输入您要查询的采购相关信息', '企业信息': '请输入您要查询的企业相关信息', '人员资质': '请输入您要查询的人员相关信息' },
      searchTheme: { '全部': '请输入您要查询的招标采购、企业名相关信息' },
    }
  },
  created() {
    this.checkUserStatus();
     this.fetchAllInfo();
    this.handleScroll();
    this.initSwiper();
  },
  methods: {

    initSwiper() {
      new Swiper(".swiper-container", {
        direction: "horizontal",
        loop: true, // 循环模式
        autoplay: {
          delay: 3000, // 自动播放间隔时间
          disableOnInteraction: false, // 用户交互后不停止自动播放
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 分页器可点击
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
    
    async fetchAllInfo() {
      try {
        const response = await fetch('/crm/index/info', {
          method: 'GET'
        });
        if (response.ok) {
          const result = await response.json();
          if (result.success) {
            this.info1 = result.data.info1 || [];
            this.info2 = result.data.info2 || [];
            this.info3 = result.data.info3 || [];
            this.info4 = result.data.info4 || [];
          } else {
            console.error('Failed to fetch data:');
          }
        } else {
          console.error('Network error:');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },

    async checkUserStatus() {
      const isAuthenticated = getWithExpiry(USER_TOKEN)
    if (isAuthenticated) {
      // 如果有 token，先发请求检查是否已登录
      axios.get("/crm/user/checkLoginStatus", {
          headers: {
            'token': isAuthenticated
          }
        }).then((response) => {
          if (response.data.status === "1") {
            // 异步操作后再跳转
            this.user = {};
          }
        }).catch(() => {
          console.info("验证登录失败");
        });
    } else {
      console.info("token失效");
    }
    },
    content() {
      this.hasShow = !this.hasShow;
    },
    contentDetail(index) {
      this.selectFault = this.select[index];
      this.hasShow = false;
      this.index = index;
    },
    // search() {
    //   window.location.href = '/index/search/index/s/' + this.nameContent + '.html';
    // },
    search() {
      // this.$router.push({
      //   path: '/index/search',
      //   query: { s: this.nameContent } // 使用输入框的值
      // });
      const searchQuery = encodeURIComponent(this.nameContent); // 对输入内容进行编码
      window.location.href = `https://vip.zhaobiaoguancha.cn/search/list?s=${searchQuery}`; // 跳转到子域名
    },
    searchThemeFun(index, con) {
      this.searchThemeCurrent = index;
      this.placeholderCon = con;
    },
    leadCon() {
      window.location.href = '/index/search/index.html?k=招标公告';
    },
    handleScroll() {
      let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
      console.log(111);
      scrolltop > 700 ? (this.gotop = true) : (this.gotop = false);
    },
    scrollTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果 
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    }
  }
  }
// })
</script>
<style scoped>
@import url("../../public/assets/static/css/reset.css");
@import url("../../public/assets/static/css/swiper.min.css");
@import url("../../public/assets/static/css/index.css");
@import url("../../public/assets/static/css/common.css");

.qr {
  position: absolute;
  top: 30%;
  right: 0;
  z-index: 99;
  width: 180px;
}
</style>